// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__otUW2","errorLogs":"EditorFooter_errorLogs__15kiP"};